import {
  badgeClasses,
  default as MuiBadge,
  type BadgeProps as MuiBadgeProps,
} from '@mui/material/Badge';
import { useTheme } from '../../../../theme';

import type { JSX } from 'react';

export type BadgeProps = Pick<MuiBadgeProps, 'overlap' | 'anchorOrigin'> & {
  children?: JSX.Element;
  content?: string | number | undefined;
  className?: string;
  invisible?: boolean;
  showZero?: boolean;
  zIndex?: number;
  background?: string;
  border?: string;
  color?: string;
  size?: 'small' | 'large';
};

export const Badge = ({
  children,
  invisible = false,
  className,
  content = '',
  showZero,
  overlap = 'circular',
  anchorOrigin = {
    vertical: 'top',
    horizontal: 'right',
  },
  zIndex,
  background,
  border,
  color,
  size = 'small',
}: BadgeProps): JSX.Element => {
  const theme = useTheme();

  const noAnchorMode = !Boolean(children);
  const isVisible = Boolean(content);

  return (
    <MuiBadge
      showZero={showZero}
      max={999}
      badgeContent={content}
      overlap={overlap}
      anchorOrigin={anchorOrigin}
      variant='standard'
      className={className}
      invisible={invisible}
      sx={{
        [`& .${badgeClasses.badge}`]: {
          zIndex,
          background,
          border,
          color,
          borderRadius: theme.shape.radius12,
          fontVariantNumeric: 'lining-nums tabular-nums',
          height: size === 'small' ? 16 : 20,
          padding: theme.spacing(0, 2),
          ...theme.typography.caption,
          ...(noAnchorMode
            ? {
                position: 'unset',
                transform: isVisible
                  ? 'unset'
                  : 'scale(0) translate(50%, -50%)',
              }
            : {}),
        },
      }}
    >
      {children}
    </MuiBadge>
  );
};
